import Icon from "@ant-design/icons";

const Component = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.1em"
    height="1.1em"
    fill="currentColor"
    viewBox="0 0 490 490"
  >
    <g>
      <g>
        <path d="M244.95,386c77.8,0,141-63.1,141-141c0-77.8-63.1-141-141-141c-40.6,0-77.2,17.2-102.9,44.6
          c-23.6,25.2-38.1,59.1-38.1,96.3C103.95,322.9,167.15,386,244.95,386z M195.75,300.8c1.3-4.6,2.5-9.3,4-13.9c1.7-5.3,3.1-6,8-3.4
          c8.4,4.4,17.2,6.8,26.5,8c6,0.7,11.9,0.1,17.4-2.3c10.4-4.5,12-16.5,3.2-23.8c-3-2.5-6.4-4.3-9.9-5.8c-9.1-4-18.6-7-27.1-12.2
          c-13.9-8.3-22.8-19.8-21.7-36.7c1.2-19.2,12-31.1,29.6-37.5c7.2-2.6,7.3-2.5,7.3-10.1c0-2.6,0-5.1,0-7.7c0.1-5.7,1.1-6.7,6.8-6.9
          c1.8-0.1,3.5,0,5.3,0c12.1,0,12.1,0,12.2,12.1c0,8.6,0,8.6,8.6,9.9c6.5,1,12.8,2.9,18.8,5.6c3.3,1.5,4.6,3.8,3.6,7.3
          c-1.5,5.2-2.9,10.5-4.6,15.7c-1.6,4.9-3.1,5.6-7.8,3.3c-9.5-4.6-19.4-6.5-29.8-5.9c-2.7,0.1-5.4,0.5-8,1.6
          c-9,3.9-10.5,13.9-2.8,20.1c3.9,3.1,8.3,5.4,12.9,7.3c8,3.3,16,6.5,23.6,10.7c24.2,13.4,30.7,43.7,13.7,64.4
          c-6.2,7.5-14.2,12.5-23.5,15.1c-4.1,1.1-5.9,3.3-5.7,7.5c0.2,4.2,0,8.3,0,12.5c0,3.7-1.9,5.7-5.6,5.8c-4.5,0.1-9,0.1-13.4,0
          c-3.9-0.1-5.8-2.3-5.8-6.1c0-3-0.1-6.1-0.1-9.1c-0.1-6.7-0.3-7-6.7-8c-8.3-1.3-16.4-3.2-23.9-6.9
          C194.65,308.5,194.05,307,195.75,300.8z"/>
        <path d="M397.65,397.8c-81.4,81.4-212.1,84.1-296.8,8.3h27.2v-29h-57.2h-0.7h-19.3v19.6v0.4v57.2h29v-28.1
          c46.6,42.5,105.8,63.8,165,63.8c62.8,0,125.5-23.9,173.3-71.7l10.3-10.3l-20.5-20.5L397.65,397.8z"/>
        <path d="M410.05,35.7v28.1C363.45,21.3,304.25,0,245.05,0c-62.8,0-125.5,23.9-173.3,71.7l-10.2,10.2l20.5,20.5l10.3-10.3
          c81.4-81.4,212.1-84.1,296.8-8.3h-27.2v29h57.2h0.7h19.3V93.2v-0.4V35.7H410.05z"/>
      </g>
    </g>
  </svg>
);

export const CreditIcon = (props) => <Icon component={Component} {...props} />;
